export default function GS_Format_Numbers() {
  return (
    <div className="p-4">
      <h1>GS Format Numbers</h1>
    </div>
  );
}
